import dataAnalyticErrorLoggingWrapper from './dataAnalyticsErrorLoggingWrapper';

export default dataAnalyticErrorLoggingWrapper;
